<template>
  <link rel="stylesheet" href="CSS/App.css">
  <div>
    <div class="gradient-bg"></div>
    <div class="findLoan-header">
      <div class="h1 find-loan-1">
        <hr2 :data-column="'findloan_h1'" v-html="BranchPage.findloan_h1"></hr2>
      </div>
      <div class="p1 find-loan-p1">
        <p style="font-style: bold" :data-column="'findloan_p1'">{{ BranchPage.findloan_p1 }}</p>
      </div>
    </div>
    <div class="double_portals">
      <card class="portal-1">
        <kButton role="button" @click="sendTo('/find-loan/purchase')" :fill-mode="'flat'" :theme-color="'primary'"
          style="height: 200px; color: black; font-size: 1.8em" :data-column="'findloan_h2'">{{ BranchPage.findloan_h2 }}
        </kbutton>
        <cardBody style="text-align: center; background-color: #006d76; color: white">
          <p :data-column="'findloan_p2'">{{ BranchPage.findloan_p2 }}</p>
        </cardBody>
      </card>
      <card class="portal-2">
        <kButton role="button" @click="sendTo('/find-loan/refinance')" :fill-mode="'flat'" :theme-color="'primary'"
          style="height: 200px; color: black; font-size: 1.8em" :data-column="'findloan_h3'">{{ BranchPage.findloan_h3 }}
        </kbutton>
        <cardBody style="text-align: center; background-color: #006d76; color: white">
          <p :data-column="'findloan_p3'">{{ BranchPage.findloan_p3 }}</p>
        </cardBody>
      </card>
    </div>
    <div class="load-resources">
      <div style="text-align: center; margin-top: 180px" class="h1 find-loan-2">
        <hr2 style="font-size: 1.5em" :data-column="'findloan_h4'">{{ BranchPage.findloan_h4 }}</hr2>
      </div>
      <div style="text-align: center; margin-top: 40px" class="p1 find-loan-3">
        <p style="font-size: 1.1em" :data-column="'findloan_p4'">{{ BranchPage.findloan_p4 }}</p>
      </div>
      <div style="margin-top: 40px" class="resource-sets">
        <div
          class="set1">
          <img alt="Drawing of man in tie" :data-column="'findloan_img1'" style="height: 100px" :src=BranchPage.findloan_img1>
          <hr2 :data-column="'findloan_h5'" style="font-size: 1.5em; margin-top: 20px">{{ BranchPage.findloan_h5 }}</hr2>
          <p :data-column="'findloan_p5'" style="font-size: 1.3em; margin-top: 20px">{{ BranchPage.findloan_p5 }}</p>
          <kButton role="button" @click="sendTo('/loan-officers')" :data-column="'findloan_button1'" :theme-color="'primary'"
            style="color: #006d76; font-size: 1.2em; background-color: white; border-color: #006d76; border-radius: 8px; border-width: 2px; width: 190px; align-self: center;">
            {{ BranchPage.findloan_button1 }}</kbutton>
        </div>
        <div
          class="set1">
          <img alt="Image of calculator" :data-column="'findloan_img2'" style="height: 100px; width: 80px; align-self: center;"
            :src=BranchPage.findloan_img2>
          <hr2 :data-column="'findloan_h6'" style="font-size: 1.5em; margin-top: 20px">{{ BranchPage.findloan_h6 }}</hr2>
          <p :data-column="'findloan_p6'" style="font-size: 1.3em; margin-top: 20px">{{ BranchPage.findloan_p6 }}</p>
          <kButton role="button" @click="sendTo('/calculators')" :data-column="'findloan_button2'" :theme-color="'primary'"
            style="color: #006d76; font-size: 1.2em; background-color: white; border-color: #006d76; border-radius: 8px; border-width: 2px; width: 230px; align-self: center;">
            {{ BranchPage.findloan_button2 }}</kbutton>
        </div>
        <div
          class="set1">
          <img alt="Drawing of man in tie" :data-column="'findloan_img3'" style="height: 100px" :src=BranchPage.findloan_img3>
          <hr2 :data-column="'findloan_h7'" style="font-size: 1.5em; margin-top: 20px">{{ BranchPage.findloan_h7 }}</hr2>
          <p :data-column="'findloan_p7'" style="font-size: 1.3em; margin-top: 20px">{{ BranchPage.findloan_p7 }}</p>
          <a @click="sendTo('/process')">
            <kButton role="button" :data-column="'findloan_button3'" :theme-color="'primary'"
              style="color: #006d76; font-size: 1.2em; background-color: white; border-color: #006d76; border-radius: 8px; border-width: 2px; width: 200px; align-self: center;">
              {{ BranchPage.findloan_button3 }}</kbutton>
          </a>
        </div>
      </div>
    </div>
    <div class="loan-star1"><img
        src="https://uploads-ssl.webflow.com/62d16d4bfd1774e5fdff161d/62d16d4bfd17746111ff1667_Group%2013.png"></div>
    <div class="show-loan-bg"></div>
    <img style="position: absolute; left: 5%"
      src="https://uploads-ssl.webflow.com/62d16d4bfd1774e5fdff161d/62d16d4bfd17746111ff1667_Group%2013.png">
    <div class="show_bg1" style="text-align: center; margin-top: 80px">
      <hr2 style="color: #fff; font-size: 2.8rem; margin-top: 40px">Loan Options Made for You</hr2>
      <p style="color: white;  margin-top: 50px; padding-bottom: 50px; font-size: 1.2em"> Every borrower’s journey is different. That’s why we offer a wide range of solutions to fit your life<br>whether you're buying, refinancing, or building your dream home.</p>
        <a href="mailto:humanresources@goldstarfinancial.com">
        <kButton :size="null" :class="'custom-size3'" :theme-color="'null'" :rounded="'large'">Contact Us</KButton>
      </a>
    </div>
    <FooterComp></FooterComp>
  </div>
</template>

<script>
import '@progress/kendo-theme-default/dist/all.css';
import apiService from '../api/api.service';
import { Card, CardBody } from "@progress/kendo-vue-layout";
import { Button } from '@progress/kendo-vue-buttons';
import FooterComp from "../components/Footer_Comp.vue";

export default {
  name: "Proccess-Page",
  components: {
    FooterComp,
    'card': Card,
    'cardBody': CardBody,
    'kButton': Button
  },


  data: function () {
    const searchParams = new URLSearchParams(window.location.search)
    var orgid = 'HQ';
    if(searchParams.has('org')){
      orgid = searchParams.get('org');
    }

    return {
      show: true,
      orgid: orgid,
      BranchPage: {},
      isLoading: false,

    };
  },

  mounted() {
    this.GetBranchPage();
  },
  methods: {
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.log(error)
        });
    },
    sendTo(url) {
      const searchParams = new URLSearchParams(window.location.search)
      if(searchParams.has('org')){
        window.location.href = url + '/?org=' + searchParams.get('org');
      }
      else
        window.location.href = url;
    }
  }
};
</script>

<style>
.findLoan-header {
  text-align: center;
  margin-top: 70px;
}

.set1{
  display: flex; flex-direction: column; text-align: center; width: 300px; margin-right: 30px;
}

.find-loan-p1 {
  text-align: center;
  width: 60%;
  margin: 0 auto;
}

.show-loan-bg {
  z-index: -100000000;
  top: 490px;
  border-radius: 50px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: 400px;
  background-color: #f9f9f9;
}

.loan-star1 {
  position: absolute;
  right: 3%;
  top: 400px;
}

.resource-sets {
  
  justify-content: center;
  display: flex;
}

.portal-1{
width: 350px; height: 250px; border-radius: 30px; border: black; border-style: solid; border-width: 2px; margin-right: 25px;

}
.portal-2{
  width: 350px; height: 250px; border-radius: 30px; border: black; border-style: solid; border-width: 2px;
}

.double_portals{
  display: flex; justify-content: center; margin-top: 260px;
}
@media (max-width: 430px){
  .double_portals{
    margin-top: 100px;
    flex-direction: column;
    width: 100%;
  }
  .loan-star1{
    display: none;
  }
  .findLoan-header{
    margin-top: 100px;
  }
  .show-loan-bg{
    display: none;
  }
  .portal-1{
    margin-left: auto;
    margin-right: auto;
    width: 300px;
  }
  .portal-2{
    margin-left: auto;
    margin-right: auto;
    width: 300px;
    margin-top: 20px;
  }
  .resource-sets{
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .set1{
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-right: 0px;
  }
  .show_bg1{
    height: 450px;
  }
}
</style>